import { Container, Stack, Typography, styled, useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import { m } from 'framer-motion';
import { MotionViewport, varFade } from 'src/components/animate';
import Carousel, { CarouselArrows, useCarousel } from 'src/components/carousel';
import Image from 'src/components/image';
import { useLocales } from 'src/locales';

const StyledCard = styled(Stack)(({ theme }) => ({}));

function HomeAbout() {
  const theme = useTheme();
  const { t } = useLocales();

  const carousel = useCarousel({
    centerMode: true,
    swipeToSlide: true,
    focusOnSelect: true,
    centerPadding: '0px',
    slidesToShow: 4,
    // auto play
    autoplay: true,
    speed: 500,
    autoplaySpeed: 2000,
    // responsive
    responsive: [
      {
        // Down 900
        breakpoint: theme.breakpoints.values.md,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        // Down 650
        breakpoint: 650,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        // Down 400
        breakpoint: 400,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  const renderCarousel = (
    <Box sx={{ position: 'relative' }}>
      <CarouselArrows
        filled
        onPrev={carousel.onPrev}
        onNext={carousel.onNext}
        leftButtonProps={{
          sx: {
            [theme.breakpoints.up('md')]: {
              display: 'none',
            },
            p: 0.5,
            mt: -1.5,
            left: -8,
            '& svg': { width: 16, height: 16 },
          },
        }}
        rightButtonProps={{
          sx: {
            [theme.breakpoints.up('md')]: {
              display: 'none',
            },
            p: 0.5,
            mt: -1.5,
            right: -8,
            '& svg': { width: 16, height: 16 },
          },
        }}
      >
        <Box
          component={Carousel}
          ref={carousel.carouselRef}
          {...carousel.carouselSettings}
          sx={{
            width: 1,
            mx: 'auto',
            // maxWidth: AVATAR_SIZE * 7 + 160,
          }}
        >
          {[...Array(4)].map((item, index) => (
            <Box key={index} sx={{ py: 5 }}>
              <StyledCard sx={{ width: '90%', margin: '0 auto' }}>
                <Image alt="screen" src={`/assets/images/home/screens/screen_${index + 1}.png`} sx={{ width: '100%', height: '100%' }} />
              </StyledCard>
            </Box>
          ))}
        </Box>
      </CarouselArrows>
    </Box>
  );

  return (
    <Container
      component={MotionViewport}
      sx={{
        py: { xs: 10, md: 15 },
      }}
    >
      <Stack spacing={3}>
        <m.div variants={varFade().inUp}>
          <Typography variant="h2" align="center" color="primary" textTransform="uppercase">
            {t('walkup_lang_008')}
          </Typography>
        </m.div>
        <m.div variants={varFade().in}>
          <Typography variant="h4" fontWeight="400" align="center" color="text.secondary">
            {t('walkup_lang_009')}
          </Typography>
        </m.div>

        {renderCarousel}
      </Stack>
    </Container>
  );
}

export default HomeAbout;
